import React, { Component } from 'react';
import {
  addGameSessionUpdatedListener,
  removeGameSessionUpdatedListener
} from 'utils/gameEvents';

// Adds game session to list of props when available

const withGameSession = () => BaseComponent => {
  class WithGameSession extends Component {
    constructor(props) {
      super(props);

      this.state = {
        gameSession: undefined
      };

      this.handleGameSessionUpdated = this.handleGameSessionUpdated.bind(this);
    }

    componentDidMount() {
      addGameSessionUpdatedListener(this.handleGameSessionUpdated);
    }

    componentWillUnmount() {
      removeGameSessionUpdatedListener(this.handleGameSessionUpdated);
    }

    handleGameSessionUpdated(gameSession) {
      if (gameSession !== this.state.gameSession) {
        this.setState({ gameSession: gameSession });
      }
    }

    render() {
      return (
        <BaseComponent {...this.props} gameSession={this.state.gameSession} />
      );
    }
  }

  return WithGameSession;
};

export default withGameSession;
